/**
 * EvolveRPG — English overrides, composed from per-feature fragments.
 * Only keys whose shared-shell (Grymwyrd-voiced) English carries world flavor are
 * re-voiced here in the fast-play, momentum-driven register; every generic UI key
 * is inherited from `baseEn`. Composed into `WorldConfig.content.en` as
 * `{ ...baseEn, ...evoEn }`.
 */
import { layoutEvoEn } from './en/layout'
import { homeEvoEn } from './en/home'
import { playEvoEn } from './en/play'
import { demoEvoEn } from './en/demo'
import { booksEvoEn } from './en/books'
import { commerceEvoEn } from './en/commerce'
import { communityEvoEn } from './en/community'
import { dashboardEvoEn } from './en/dashboard'
import { authEvoEn } from './en/auth'
import { marketingEvoEn } from './en/marketing'
import { worldEvoEn } from './en/world'
import { encyclopediaEvoEn } from './en/encyclopedia'
import { systemEvoEn } from './en/system'
import type { MessageCatalog } from '@gamecodex/world-config'

export const evoEn: MessageCatalog = {
  ...layoutEvoEn,
  ...homeEvoEn,
  ...playEvoEn,
  ...demoEvoEn,
  ...booksEvoEn,
  ...commerceEvoEn,
  ...communityEvoEn,
  ...dashboardEvoEn,
  ...authEvoEn,
  ...marketingEvoEn,
  ...worldEvoEn,
  ...encyclopediaEvoEn,
  ...systemEvoEn,
}
